import type { LocationQuery } from 'vue-router'
import type { NextLaunchContext } from '@/types/api'

function pickFirst(value: LocationQuery[string] | undefined): string | undefined {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : undefined
  }

  return typeof value === 'string' ? value : undefined
}

export function extractNextLaunchContext(query: LocationQuery): NextLaunchContext | null {
  const source = pickFirst(query.source)
  const tenantName = pickFirst(query.tenantName)
  const themeName = pickFirst(query.themeName)
  const themeSystemValueId = pickFirst(query.themeSystemValueId)
  const returnUrl = pickFirst(query.returnUrl)
  const displayName = pickFirst(query.displayName)
  const description = pickFirst(query.description)
  const handoffToken = pickFirst(query.handoffToken)

  const hasContext = source === 'next' || !!tenantName || !!themeName || !!themeSystemValueId || !!returnUrl || !!handoffToken
  if (!hasContext) {
    return null
  }

  return {
    sourceApp: 'next',
    tenantName,
    themeName,
    themeSystemValueId,
    returnUrl,
    displayName,
    description,
    handoffToken
  }
}
